module.exports = __webpack_public_path__ + "static/media/FM.0164b256.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/FM.svg
// module id = 253
// module chunks = 0